import { Component, OnDestroy, OnInit } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router, RouterStateSnapshot } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { CredentialService } from "../../credential.service";
import { DownloadContractService } from "./download-contract.service";
import { TranslateService } from "@ngx-translate/core";
import { redirectIfAllowed } from "../../utils/redirect.util";

declare var $;

@Component({
  standalone: false,
  selector: "app-contract-download",
  templateUrl: "./contract-download.component.html",
  styleUrls: ["./contract-download.component.scss"]
})
export class ContractDownloadComponent implements OnInit, OnDestroy {
  user;
  return_URL: string;
  token: string;
  isSuccess = false;
  isError = false;
  isLoading = false;
  title: string;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private routes: ActivatedRoute,
    private router: Router,
    private _credentialService: CredentialService,
    private downloadContractService: DownloadContractService,
    private translateService: TranslateService
  ) {
    this.user = localStorage.getItem("user") ? localStorage.getItem("user") : null;
    this.token = localStorage.getItem("token") ? localStorage.getItem("token") : null;
    const snapshot: RouterStateSnapshot = router.routerState.snapshot;
    this.return_URL = snapshot.url;
    this.title = this.translateService.instant("contract-download.Your_contract_is_downloading");
  }

  ngOnInit() {
    if (!this.token || !this.user) {
      this.router.navigate(["login"], {
        queryParams: { returnUrl: this.return_URL }
      });
    } else {
      if (this.routes.snapshot.paramMap.get("id")) {
        const reqBody = {
          isComplete: true
        };
        const reqheader = new HttpHeaders().set("authorization", this.token);
        this.downloadContractService
          .downloadContract(this.routes.snapshot.paramMap.get("id"), reqBody, reqheader)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            res => {
              redirectIfAllowed(res.link);
              this.isSuccess = true;
              setTimeout(() => {
                this.redirect();
              }, 5000);
            },
            err => {
              if (err.error.error && err.error.error === "AUTH_FAIL") {
                this._credentialService.logout();
              } else if (err.error.error && err.error.error === "NOT_FOUND") {
                this.title = this.translateService.instant("contract-download.Contract_not_found_for_download");
                this.isError = true;
                this.isSuccess = true;
                setTimeout(() => {
                  this.redirect();
                }, 5000);
              }
            }
          );
      }
    }
    $("#initial_loader").remove();
  }

  redirect() {
    this.isLoading = true;
    this.router.navigate(["dashboard"]);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
